export enum PageType {
  OFFER = 0,
  CUSTOMER = 1
}
